<template lang="pug">
  div
    Header
    v-content
      transition
        router-view
</template>

<script>
export default {
  components: {
    Header: () => import('../../components/Header')
  }
}
</script>
